import { GroupedBasketItemTypes } from '@common/components/ItemListingRows/ItemListingRows';
import { useTranslations } from '@lang';
import { PackageStack, PackageText, PackageTitle } from '../BasketDrawer.styles';
import { DiningListing } from '../DiningListing';
import { RoomListing } from '../RoomListing';
import { SpaListing } from '../SpaListing';

export const PackageListing = ({ packages }: { packages: GroupedBasketItemTypes['packages'] }) => {
  const { t } = useTranslations();
  return (
    <>
      {packages?.map((p, index) => {
        const { rooms, spa, tables } = p;
        return (
          <div data-testid="package-listing" key={`package-${index}`}>
            <PackageTitle>{rooms[0].bookable?.rate}</PackageTitle>
            {rooms && (
              <PackageStack direction="horizontal" alignItems="baseline" gap={2}>
                <PackageText>{t('basketDrawer.packages.rooms')}</PackageText>
                <RoomListing rooms={rooms} />
              </PackageStack>
            )}
            {spa && (
              <PackageStack direction="horizontal" alignItems="baseline" gap={2}>
                <PackageText>{t('basketDrawer.packages.spa')}</PackageText>
                <SpaListing spa={spa} hideArrivalTimes />
              </PackageStack>
            )}
            {tables && (
              <PackageStack direction="horizontal" alignItems="baseline" gap={2}>
                <PackageText>{t('basketDrawer.packages.dining')}</PackageText>
                <DiningListing tables={tables} />
              </PackageStack>
            )}
          </div>
        );
      })}
    </>
  );
};
